import { AfterViewInit, Renderer2, ElementRef } from '@angular/core';
var EnginesOptionDynamicHeightDirective = /** @class */ (function () {
    function EnginesOptionDynamicHeightDirective(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    Object.defineProperty(EnginesOptionDynamicHeightDirective.prototype, "searchEngineCount", {
        get: function () {
            return this._searchEngineCount;
        },
        set: function (value) {
            if (value) {
                this._searchEngineCount = value;
                this.adjustHeight();
            }
        },
        enumerable: true,
        configurable: true
    });
    EnginesOptionDynamicHeightDirective.prototype.onResize = function () {
        this.adjustHeight();
    };
    EnginesOptionDynamicHeightDirective.prototype.ngAfterViewInit = function () {
    };
    EnginesOptionDynamicHeightDirective.prototype.adjustHeight = function () {
        var rowHeightDesktop = 45;
        var rowHeightMobile = 60;
        var columnCount = 2;
        var mobileBreakPoint = 767;
        var totalHeight;
        if (window.innerWidth > mobileBreakPoint) {
            totalHeight = Math.ceil(this.searchEngineCount / columnCount) * rowHeightDesktop;
        }
        else {
            totalHeight = Math.ceil(this.searchEngineCount / columnCount) * rowHeightMobile;
        }
        this.renderer.setStyle(this.elementRef.nativeElement, 'height', totalHeight + 'px');
    };
    return EnginesOptionDynamicHeightDirective;
}());
export { EnginesOptionDynamicHeightDirective };
